import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MarketScreen = ({ user }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("stocks");
  const [searchTerm, setSearchTerm] = useState("");

  // Mock market data
  const stocks = [
    { symbol: "AAPL", name: "Apple Inc.", price: "$150.23", change: "+$2.45", changePercent: "+1.66%", volume: "45.2M" },
    { symbol: "TSLA", name: "Tesla Inc.", price: "$245.67", change: "-$3.21", changePercent: "-1.29%", volume: "32.1M" },
    { symbol: "MSFT", name: "Microsoft Corp.", price: "$378.45", change: "+$5.67", changePercent: "+1.52%", volume: "28.9M" },
    { symbol: "GOOGL", name: "Alphabet Inc.", price: "$142.89", change: "+$1.23", changePercent: "+0.87%", volume: "22.4M" },
    { symbol: "AMZN", name: "Amazon.com Inc.", price: "$178.34", change: "-$2.78", changePercent: "-1.53%", volume: "35.7M" },
    { symbol: "META", name: "Meta Platforms", price: "$298.76", change: "+$4.12", changePercent: "+1.40%", volume: "18.3M" },
  ];

  const cryptocurrencies = [
    { symbol: "BTC", name: "Bitcoin", price: "$43,567.89", change: "+$1,234.56", changePercent: "+2.92%", volume: "28.5B" },
    { symbol: "ETH", name: "Ethereum", price: "$2,345.67", change: "+$67.89", changePercent: "+2.98%", volume: "15.2B" },
    { symbol: "BNB", name: "Binance Coin", price: "$312.45", change: "-$5.67", changePercent: "-1.78%", volume: "2.1B" },
    { symbol: "SOL", name: "Solana", price: "$98.76", change: "+$3.45", changePercent: "+3.62%", volume: "1.8B" },
    { symbol: "ADA", name: "Cardano", price: "$0.45", change: "+$0.02", changePercent: "+4.65%", volume: "890M" },
    { symbol: "DOT", name: "Polkadot", price: "$7.89", change: "-$0.12", changePercent: "-1.50%", volume: "450M" },
  ];

  const etfs = [
    { symbol: "SPY", name: "SPDR S&P 500 ETF Trust", price: "$450.23", change: "+$2.12", changePercent: "+0.47%", volume: "75.2M" },
    { symbol: "QQQ", name: "Invesco QQQ Trust", price: "$370.45", change: "+$1.67", changePercent: "+0.45%", volume: "32.9M" },
    { symbol: "VTI", name: "Vanguard Total Stock Market ETF", price: "$230.12", change: "-$0.45", changePercent: "-0.20%", volume: "18.7M" },
    { symbol: "EFA", name: "iShares MSCI EAFE ETF", price: "$80.34", change: "+$0.23", changePercent: "+0.29%", volume: "12.3M" },
    { symbol: "IEMG", name: "iShares Core MSCI Emerging Markets ETF", price: "$54.67", change: "-$0.12", changePercent: "-0.22%", volume: "9.8M" },
  ];

  const currencies = [
    { symbol: "USD", name: "US Dollar", price: "$1.00", change: "-", changePercent: "-", volume: "-" },
    { symbol: "EUR", name: "Euro", price: "$1.09", change: "+$0.01", changePercent: "+0.92%", volume: "-" },
    { symbol: "GBP", name: "British Pound", price: "$1.27", change: "-$0.01", changePercent: "-0.78%", volume: "-" },
    { symbol: "JPY", name: "Japanese Yen", price: "$0.0071", change: "+$0.0001", changePercent: "+1.43%", volume: "-" },
    { symbol: "CHF", name: "Swiss Franc", price: "$1.13", change: "+$0.01", changePercent: "+0.89%", volume: "-" },
    { symbol: "DKK", name: "Danish Krone", price: "$0.15", change: "+$0.001", changePercent: "+0.67%", volume: "-" },
  ];

  let filteredData = [];
  if (activeTab === "stocks") filteredData = stocks;
  else if (activeTab === "crypto") filteredData = cryptocurrencies;
  else if (activeTab === "etfs") filteredData = etfs;
  else if (activeTab === "currencies") filteredData = currencies;
  filteredData = filteredData.filter(
    item => item.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
            item.symbol.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Dla niezalogowanych: 4 zakładki, bez watchlist/your stocks
  if (!user) {
    return (
      <div className="screen">
        <div className="screen-header" style={{ marginTop: 56 }}>
          <h1 className="screen-title">Market Overview</h1>
          <p className="screen-subtitle">Track stocks, cryptos, ETFs and currencies in real-time</p>
        </div>
        {/* Search Bar */}
        <div className="card">
          <div className="form-group">
            <input
              type="text"
              className="form-input"
              placeholder="Search stocks, cryptos, ETFs or currencies..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        {/* Tab Navigation */}
        <div className="card">
          <div className="flex gap-2" style={{ marginBottom: "20px" }}>
            <button
              onClick={() => setActiveTab("stocks")}
              className={`btn ${activeTab === "stocks" ? "" : "btn-outline"}`}
            >
              📈 Stocks
            </button>
            <button
              onClick={() => setActiveTab("crypto")}
              className={`btn ${activeTab === "crypto" ? "" : "btn-outline"}`}
            >
              🪙 Cryptos
            </button>
            <button
              onClick={() => setActiveTab("etfs")}
              className={`btn ${activeTab === "etfs" ? "" : "btn-outline"}`}
            >
              📊 ETFs
            </button>
            <button
              onClick={() => setActiveTab("currencies")}
              className={`btn ${activeTab === "currencies" ? "" : "btn-outline"}`}
            >
              💱 Currencies
            </button>
          </div>
          {/* Market Data */}
          <div className="grid-2">
            {filteredData.map((item, index) => (
              <div
                key={index}
                className="stock-item"
                style={{ cursor: "pointer" }}
              >
                <div className="stock-header">
                  <div>
                    <div className="stock-name">{item.name}</div>
                    <div className="stock-symbol">{item.symbol}</div>
                  </div>
                  <div className="text-right">
                    <div className="stock-price">{item.price}</div>
                    <div className={`stock-change ${item.changePercent && item.changePercent.startsWith('+') ? 'positive' : 'negative'}`}>
                      {item.change} {item.changePercent && `(${item.changePercent})`}
                    </div>
                  </div>
                </div>
                {item.volume && (
                  <div style={{ color: "#94A3B8", fontSize: "0.9rem" }}>
                    Volume: {item.volume}
                  </div>
                )}
              </div>
            ))}
          </div>
          {filteredData.length === 0 && (
            <div className="text-center" style={{ color: "#94A3B8", padding: "40px" }}>
              No results found for "{searchTerm}"
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="screen">
      <div className="screen-header" style={{ marginTop: 56 }}>
        <h1 className="screen-title">Market Overview</h1>
        <p className="screen-subtitle">Track stocks and cryptocurrencies in real-time</p>
      </div>

      {/* Search Bar */}
      <div className="card">
        <div className="form-group">
          <input
            type="text"
            className="form-input"
            placeholder="Search stocks or cryptocurrencies..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="card">
        <div className="flex gap-2" style={{ marginBottom: "20px" }}>
          <button
            onClick={() => setActiveTab("stocks")}
            className={`btn ${activeTab === "stocks" ? "" : "btn-outline"}`}
          >
            📈 Stocks
          </button>
          <button
            onClick={() => setActiveTab("crypto")}
            className={`btn ${activeTab === "crypto" ? "" : "btn-outline"}`}
          >
            🪙 Cryptocurrencies
          </button>
        </div>

        {/* Market Data */}
        <div className="grid-2">
          {filteredData.map((item, index) => (
            <div
              key={index}
              className="stock-item"
              onClick={() => navigate(
                activeTab === "stocks" 
                  ? `/stock-detail/${item.symbol}` 
                  : `/currency-detail/${item.symbol}`
              )}
            >
              <div className="stock-header">
                <div>
                  <div className="stock-name">{item.name}</div>
                  <div className="stock-symbol">{item.symbol}</div>
                </div>
                <div className="text-right">
                  <div className="stock-price">{item.price}</div>
                  <div className={`stock-change ${item.changePercent.startsWith('+') ? 'positive' : 'negative'}`}>
                    {item.change} ({item.changePercent})
                  </div>
                </div>
              </div>
              <div style={{ color: "#94A3B8", fontSize: "0.9rem" }}>
                Volume: {item.volume}
              </div>
            </div>
          ))}
        </div>

        {filteredData.length === 0 && (
          <div className="text-center" style={{ color: "#94A3B8", padding: "40px" }}>
            No results found for "{searchTerm}"
          </div>
        )}
      </div>

      {/* Market Stats */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Market Statistics</h3>
        </div>
        <div className="grid-3">
          <div className="portfolio-card">
            <div className="portfolio-value">$2.1T</div>
            <div className="portfolio-label">Total Market Cap</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">$45.2B</div>
            <div className="portfolio-label">24h Volume</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">+2.34%</div>
            <div className="portfolio-label">Market Change</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketScreen; 